import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, toHandlers as _toHandlers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_tab = _resolveComponent("q-tab")!
  const _component_creation_menu_content = _resolveComponent("creation-menu-content")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_route_tab = _resolveComponent("q-route-tab")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_account_menu_content = _resolveComponent("account-menu-content")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_quick_search = _resolveComponent("quick-search")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_tabs, {
      "active-color": "primary",
      "indicator-color": "primary",
      "no-caps": "",
      align: "justify",
      "outside-arrows": "",
      "mobile-arrows": "",
      class: "text-grey-dark",
      "left-icon": _ctx.ICONS_NAME.CHEVRON_LEFT_SOLID,
      "right-icon": _ctx.ICONS_NAME.CHEVRON_RIGHT_SOLID,
      modelValue: _ctx.tab,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.tab) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_tab, {
          class: "no-active-color",
          name: "search",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.displaySearch = true))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, {
              side: "",
              class: "q-pa-sm"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_icon, _mergeProps({ color: "grey-dark" }, _ctx.ICON_PROPS.MENU, {
                  name: _ctx.ICONS_NAME.SEARCH_OUTLINE
                }), null, 16, ["name"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_tab, {
          id: "createLeadFooterButtonId",
          class: "no-active-color",
          onClick: _ctx.tabClicked,
          name: "add"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_icon, _mergeProps(_ctx.ICON_PROPS.MENU, {
              color: "grey-dark",
              name: _ctx.ICONS_NAME.PLUS_OUTLINE
            }), null, 16, ["name"]),
            (!_ctx.isContributor)
              ? (_openBlock(), _createBlock(_component_q_menu, {
                  key: 0,
                  anchor: "top middle",
                  self: "bottom middle",
                  class: "bordered shadow-3 text-body2 drawer-menu",
                  offset: [0, 8],
                  onBeforeShow: _cache[1] || (_cache[1] = ($event: any) => (_ctx.menuShow = true)),
                  onBeforeHide: _cache[2] || (_cache[2] = ($event: any) => (_ctx.menuShow = false))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_creation_menu_content, { "import-allowed": false })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_q_route_tab, {
          to: { name: _ctx.ROUTE_DATA.LEAD_HUB_PAGE.name },
          class: _normalizeClass({ 'q-tab--active': _ctx.$route.name === _ctx.ROUTE_DATA.LEAD_HUB_PAGE_BOARD.name }),
          id: "leadsFooterButtonId",
          name: "leads"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_icon, _mergeProps(_ctx.ICON_PROPS.MENU, {
              color: "grey-dark",
              name: _ctx.ICONS_NAME.FILE_OUTLINE
            }), null, 16, ["name"])
          ]),
          _: 1
        }, 8, ["to", "class"]),
        _createVNode(_component_q_route_tab, {
          to: { name: _ctx.ROUTE_DATA.DASHBOARD_HUB_PAGE.name },
          class: _normalizeClass({ 'q-tab--active': _ctx.$route.name === _ctx.ROUTE_DATA.DASHBOARD_HUB_PAGE_BOARD.name }),
          id: "dashboardFooterButtonId",
          name: "dashboard"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_icon, _mergeProps(_ctx.ICON_PROPS.MENU, {
              color: "grey-dark",
              name: _ctx.ICONS_NAME.CHART_BAR_OUTLINE
            }), null, 16, ["name"])
          ]),
          _: 1
        }, 8, ["to", "class"]),
        _createVNode(_component_q_tab, {
          id: "moreFooterButtonId",
          class: "no-active-color",
          name: "more"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_icon, _mergeProps(_ctx.ICON_PROPS.MENU, {
              color: "grey-dark",
              name: _ctx.ICONS_NAME.MORE_SOLID
            }), null, 16, ["name"]),
            _createVNode(_component_q_menu, {
              anchor: "top middle",
              self: "bottom middle",
              class: "bordered shadow-3 text-body2 drawer-menu",
              offset: [8, 0],
              onBeforeShow: _cache[5] || (_cache[5] = ($event: any) => (_ctx.menuShow = true)),
              onBeforeHide: _cache[6] || (_cache[6] = ($event: any) => (_ctx.menuShow = false))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_list, {
                  padding: "",
                  class: "q-px-sm"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.moreItems, (item) => {
                      return _withDirectives((_openBlock(), _createBlock(_component_q_item, _mergeProps({
                        key: item.label
                      }, _ctx.TEXT_SMALL_BODY, {
                        to: item.to
                      }, _toHandlers(item.name === _ctx.MORE_ITEMS.CONTACTS ? { click: _ctx.trackContactMenu } : {}), {
                        onClick: _ctx.trackContactMenu,
                        id: "contactsFooterButtonId"
                      }), {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { side: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, _mergeProps(_ctx.ICON_PROPS.MENU, {
                                color: "grey-dark",
                                name: item.icon
                              }), null, 16, ["name"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.label), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1040, ["to", "onClick"])), [
                        [_directive_close_popup]
                      ])
                    }), 128)),
                    _createVNode(_component_q_item, _normalizeProps(_guardReactiveProps(_ctx.TEXT_SMALL_BODY)), {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_section, { side: "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_icon, _mergeProps(_ctx.ICON_PROPS.MENU, {
                              color: "grey-dark",
                              name: _ctx.ICONS_NAME.COG_OUTLINE
                            }), null, 16, ["name"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_q_item_section, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('SETTINGS')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_q_menu, {
                          anchor: "top middle",
                          self: "bottom middle",
                          class: "bordered shadow-3 text-body2 drawer-menu",
                          offset: [8, 0],
                          onBeforeShow: _cache[3] || (_cache[3] = ($event: any) => (_ctx.menuShow = true)),
                          onBeforeHide: _cache[4] || (_cache[4] = ($event: any) => (_ctx.menuShow = false))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_account_menu_content, { mobile: "" })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 16)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["left-icon", "right-icon", "modelValue"]),
    _createVNode(_component_q_dialog, {
      "model-value": _ctx.displaySearch,
      position: "top",
      "transition-hide": "none",
      "transition-show": "none",
      onHide: _cache[10] || (_cache[10] = ($event: any) => (_ctx.displaySearch = false))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { class: "column no-wrap" }, {
          default: _withCtx(() => [
            _createVNode(_component_quick_search, {
              onCreate: _cache[8] || (_cache[8] = ($event: any) => {
                    _ctx.displaySearch = false;
                    _ctx.createLead({ briefId: _ctx.currentBriefId });
                }),
              onSearch: _cache[9] || (_cache[9] = 
                    (searchTerm) => {
                        _ctx.displaySearch = false;
                        _ctx.$router.push({
                            name: _ctx.ROUTE_DATA.LEAD_HUB_PAGE_BOARD.name,
                            params: { id: _ctx.allBoardId.toString() },
                            query: { searchText: searchTerm }
                        });
                    }
                )
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model-value"])
  ], 64))
}